export const localAdConfig = {
    clientId: '55900821-f46f-4e49-971d-80e82f02c8ec',
    authority: 'https://login.microsoftonline.com/e7520e4d-d5a0-488d-9e9f-949faae7dce8',
    redirectUri: '/', //as default value "navigateToLoginRequestUrl" is true, so it will redirect to the page where the user initiated the login process
    postLogoutRedirectUri: "/",
};

export const prodAdConfig = {
    clientId: '0e70c0c5-a816-4016-bece-45bafc5d9784',
    authority: 'https://login.microsoftonline.com/e7520e4d-d5a0-488d-9e9f-949faae7dce8',
    redirectUri: '/', //as default value "navigateToLoginRequestUrl" is true, so it will redirect to the page where the user initiated the login process
    postLogoutRedirectUri: "/",
};